import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { isMobile } from './utils/device'

const app = createApp(App)

// 配置 axios
axios.defaults.baseURL = '/api'
axios.interceptors.request.use((config) => {
  const token = store.state.token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      store.commit('setToken', null)
      store.commit('setUser', null)
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

// 屏蔽 ResizeObserver 报错
const originalError = console.error
console.error = function (...args) {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('ResizeObserver')) {
    return
  }
  originalError.apply(console, args)
}

const debounce = (fn, delay) => {
  let timer
  return (...args) => {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => fn(...args), delay)
  }
}

const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 200)
    super(callback)
  }
}

app.config.globalProperties.$axios = axios
app.use(store)
app.use(router)

// 设备分支：使用动态 import 让 webpack 生成独立 chunk，
// PC 用户不会下载 H5 适配脚本，H5 用户不会下载 Element Plus
const bootstrap = async () => {
  if (isMobile()) {
    await import(/* webpackChunkName: "h5-flexible" */ 'amfe-flexible')
  } else {
    const [{ default: ElementPlus }] = await Promise.all([
      import(/* webpackChunkName: "element-plus" */ 'element-plus'),
      import(/* webpackChunkName: "element-plus" */ 'element-plus/dist/index.css'),
    ])
    app.use(ElementPlus)
  }
  app.mount('#app')
}

bootstrap()
